<div id="progress">
  <span id="progress-value"></span>
</div>
